import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import { getTitle } from 'utils/owner';
import { getPhotoURL } from 'utils/images';
import css from './UpcomingOwner.css';

export default class UpcomingOwner extends React.Component {

  render() {
    return (
      <div className={css['owner-container']}>
        <div
          className="avatar"
          style={{backgroundImage: `url(${getPhotoURL(this.props.uuid, this.props.photoAvailable)})`}}
        />
        <div>
          <div className="name">{this.props.name}</div>
          <div className="title">{getTitle(this.props.title, this.props.roles)}</div>
        </div>
      </div>
    );
  }
}

UpcomingOwner.propTypes = {
  id: SFEntityID.isRequired,
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
  photoAvailable: PropTypes.bool
};
